module.exports = __webpack_public_path__ + "static/media/search_icon_blue.71c3854b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/search_icon_blue.svg
// module id = 310
// module chunks = 2